export const Registration = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.99081 13.9976L11.1106 9.96813C13.3959 7.70281 13.4121 4.01381 11.1468 1.72853C8.88146 -0.556755 5.19246 -0.57297 2.90718 1.69235C2.89507 1.70435 2.88301 1.71641 2.87101 1.72853C0.595705 4.00388 0.595732 7.69291 2.87109 9.96821C2.87262 9.96974 2.87415 9.97127 2.87568 9.9728L6.99081 13.9976ZM3.69485 2.55237C5.51386 0.73078 8.46518 0.728675 10.2868 2.54772C12.1084 4.36676 12.1105 7.31805 10.2914 9.13964L6.99081 12.3674L3.69485 9.14429C1.87455 7.32407 1.87446 4.37286 3.69468 2.55253C3.69474 2.55248 3.69479 2.55242 3.69485 2.55237ZM6.40817 6.43097H4.66027V5.26569H6.40817V3.51779H7.57342V5.26569H9.32131V6.43097H7.57342V8.17886H6.40817V6.43097Z"
      fill="currentColor"
    />
  </svg>
);
